/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigation API
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { AdditionalFile } from '../models';
import { AdditionalFileIEnumerableResponse } from '../models';
import { AdminComplianceFormRequest } from '../models';
import { BooleanResponse } from '../models';
import { ComplianceFormAbsolutionRequest } from '../models';
import { ComplianceFormAbsolutionResponse } from '../models';
import { ComplianceFormFileResponse } from '../models';
import { ComplianceFormIEnumerableResponse } from '../models';
import { ComplianceFormTip } from '../models';
import { ComplianceFormTipIEnumerableResponse } from '../models';
import { ComplianceFormTrustInvestigator } from '../models';
import { ComplianceYearIEnumerableResponse } from '../models';
import { GenerateNextYearTrustComplianceFormResponse } from '../models';
import { NumberOfCompliantFormsResponse } from '../models';
import { ProgressIEnumerableResponse } from '../models';
/**
 * ComplianceFormApi - axios parameter creator
 * @export
 */
export const ComplianceFormApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TaAll | Dashboard Number Of Compliant Forms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormAdminDashboardGetNumberOfCompliantFormsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ComplianceForm/Admin/Dashboard/GetNumberOfCompliantForms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Generate Next Year Trust ComplianceForm
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormAdminGenerateNextYearTrustComplianceFormPracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV2ComplianceFormAdminGenerateNextYearTrustComplianceFormPracticeIdGet.');
            }
            const localVarPath = `/api/v2/ComplianceForm/Admin/GenerateNextYearTrustComplianceForm/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Compliance Form Absolution
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormAdminGetComplianceFormAbsolutionComplianceFormIdGet: async (complianceFormId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'complianceFormId' is not null or undefined
            if (complianceFormId === null || complianceFormId === undefined) {
                throw new RequiredError('complianceFormId','Required parameter complianceFormId was null or undefined when calling apiV2ComplianceFormAdminGetComplianceFormAbsolutionComplianceFormIdGet.');
            }
            const localVarPath = `/api/v2/ComplianceForm/Admin/GetComplianceFormAbsolution/{complianceFormId}`
                .replace(`{${"complianceFormId"}}`, encodeURIComponent(String(complianceFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns ComplianceForm AdditionalFiles
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormAdminGetComplianceFormAdditionalFilesComplianceFormIdGet: async (complianceFormId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'complianceFormId' is not null or undefined
            if (complianceFormId === null || complianceFormId === undefined) {
                throw new RequiredError('complianceFormId','Required parameter complianceFormId was null or undefined when calling apiV2ComplianceFormAdminGetComplianceFormAdditionalFilesComplianceFormIdGet.');
            }
            const localVarPath = `/api/v2/ComplianceForm/Admin/GetComplianceFormAdditionalFiles/{complianceFormId}`
                .replace(`{${"complianceFormId"}}`, encodeURIComponent(String(complianceFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Compliance Form Files
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormAdminGetComplianceFormFilesComplianceFormIdGet: async (complianceFormId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'complianceFormId' is not null or undefined
            if (complianceFormId === null || complianceFormId === undefined) {
                throw new RequiredError('complianceFormId','Required parameter complianceFormId was null or undefined when calling apiV2ComplianceFormAdminGetComplianceFormFilesComplianceFormIdGet.');
            }
            const localVarPath = `/api/v2/ComplianceForm/Admin/GetComplianceFormFiles/{complianceFormId}`
                .replace(`{${"complianceFormId"}}`, encodeURIComponent(String(complianceFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Compliance Forms
         * @param {AdminComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormAdminGetComplianceFormsPost: async (body?: AdminComplianceFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ComplianceForm/Admin/GetComplianceForms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns boolean if Generate Trust Compliance Form is enabled
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormAdminIsGenerateTrustComplianceFormEnablePracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV2ComplianceFormAdminIsGenerateTrustComplianceFormEnablePracticeIdGet.');
            }
            const localVarPath = `/api/v2/ComplianceForm/Admin/IsGenerateTrustComplianceFormEnable/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All  | Update Compliance Form Absolution
         * @param {ComplianceFormAbsolutionRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormAdminUpdateComplianceFormAbsolutionPost: async (body?: ComplianceFormAbsolutionRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ComplianceForm/Admin/UpdateComplianceFormAbsolution`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact / ExternalExaminer | Returns Compliance Forms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormGetComplianceFormsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ComplianceForm/GetComplianceForms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / TrustCoordinator / TrustContact / ExternalExaminer | Returns Compliance Years
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormGetComplianceYearsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ComplianceForm/GetComplianceYears`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Principal / TrustCoordinator / TrustContact / ExternalExaminer | Returns Progresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormGetProgressesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ComplianceForm/GetProgresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Trust Investigator only | Returns ComplianceForm AdditionalFiles
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormTrustInvestigatorGetComplianceFormAdditionalFilesComplianceFormIdGet: async (complianceFormId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'complianceFormId' is not null or undefined
            if (complianceFormId === null || complianceFormId === undefined) {
                throw new RequiredError('complianceFormId','Required parameter complianceFormId was null or undefined when calling apiV2ComplianceFormTrustInvestigatorGetComplianceFormAdditionalFilesComplianceFormIdGet.');
            }
            const localVarPath = `/api/v2/ComplianceForm/TrustInvestigator/GetComplianceFormAdditionalFiles/{complianceFormId}`
                .replace(`{${"complianceFormId"}}`, encodeURIComponent(String(complianceFormId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Trust Investigator only | Returns Compliance Forms
         * @param {AdminComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormTrustInvestigatorGetComplianceFormsPost: async (body?: AdminComplianceFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ComplianceForm/TrustInvestigator/GetComplianceForms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Trust Investigator only | Returns Compliance Forms
         * @param {AdminComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormTrustInvestigatorGetComplianceFormsTipPost: async (body?: AdminComplianceFormRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ComplianceForm/TrustInvestigator/GetComplianceFormsTip`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComplianceFormApi - functional programming interface
 * @export
 */
export const ComplianceFormApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TaAll | Dashboard Number Of Compliant Forms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormAdminDashboardGetNumberOfCompliantFormsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NumberOfCompliantFormsResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormAdminDashboardGetNumberOfCompliantFormsGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Generate Next Year Trust ComplianceForm
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormAdminGenerateNextYearTrustComplianceFormPracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormAdminGenerateNextYearTrustComplianceFormPracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Compliance Form Absolution
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormAdminGetComplianceFormAbsolutionComplianceFormIdGet(complianceFormId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplianceFormAbsolutionResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormAdminGetComplianceFormAbsolutionComplianceFormIdGet(complianceFormId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns ComplianceForm AdditionalFiles
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormAdminGetComplianceFormAdditionalFilesComplianceFormIdGet(complianceFormId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdditionalFileIEnumerableResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormAdminGetComplianceFormAdditionalFilesComplianceFormIdGet(complianceFormId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Compliance Form Files
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormAdminGetComplianceFormFilesComplianceFormIdGet(complianceFormId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplianceFormFileResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormAdminGetComplianceFormFilesComplianceFormIdGet(complianceFormId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Compliance Forms
         * @param {AdminComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormAdminGetComplianceFormsPost(body?: AdminComplianceFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplianceFormTipIEnumerableResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormAdminGetComplianceFormsPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns boolean if Generate Trust Compliance Form is enabled
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormAdminIsGenerateTrustComplianceFormEnablePracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateNextYearTrustComplianceFormResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormAdminIsGenerateTrustComplianceFormEnablePracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All  | Update Compliance Form Absolution
         * @param {ComplianceFormAbsolutionRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormAdminUpdateComplianceFormAbsolutionPost(body?: ComplianceFormAbsolutionRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormAdminUpdateComplianceFormAbsolutionPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact / ExternalExaminer | Returns Compliance Forms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormGetComplianceFormsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplianceFormIEnumerableResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormGetComplianceFormsGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / TrustCoordinator / TrustContact / ExternalExaminer | Returns Compliance Years
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormGetComplianceYearsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplianceYearIEnumerableResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormGetComplianceYearsGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Principal / TrustCoordinator / TrustContact / ExternalExaminer | Returns Progresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormGetProgressesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProgressIEnumerableResponse>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormGetProgressesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Trust Investigator only | Returns ComplianceForm AdditionalFiles
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormTrustInvestigatorGetComplianceFormAdditionalFilesComplianceFormIdGet(complianceFormId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdditionalFile>>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormTrustInvestigatorGetComplianceFormAdditionalFilesComplianceFormIdGet(complianceFormId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Trust Investigator only | Returns Compliance Forms
         * @param {AdminComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormTrustInvestigatorGetComplianceFormsPost(body?: AdminComplianceFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ComplianceFormTrustInvestigator>>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormTrustInvestigatorGetComplianceFormsPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Trust Investigator only | Returns Compliance Forms
         * @param {AdminComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ComplianceFormTrustInvestigatorGetComplianceFormsTipPost(body?: AdminComplianceFormRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ComplianceFormTip>>> {
            const localVarAxiosArgs = await ComplianceFormApiAxiosParamCreator(configuration).apiV2ComplianceFormTrustInvestigatorGetComplianceFormsTipPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ComplianceFormApi - factory interface
 * @export
 */
export const ComplianceFormApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary TaAll | Dashboard Number Of Compliant Forms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormAdminDashboardGetNumberOfCompliantFormsGet(options?: any): AxiosPromise<NumberOfCompliantFormsResponse> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormAdminDashboardGetNumberOfCompliantFormsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Generate Next Year Trust ComplianceForm
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormAdminGenerateNextYearTrustComplianceFormPracticeIdGet(practiceId: number, options?: any): AxiosPromise<BooleanResponse> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormAdminGenerateNextYearTrustComplianceFormPracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Compliance Form Absolution
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormAdminGetComplianceFormAbsolutionComplianceFormIdGet(complianceFormId: number, options?: any): AxiosPromise<ComplianceFormAbsolutionResponse> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormAdminGetComplianceFormAbsolutionComplianceFormIdGet(complianceFormId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns ComplianceForm AdditionalFiles
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormAdminGetComplianceFormAdditionalFilesComplianceFormIdGet(complianceFormId: number, options?: any): AxiosPromise<AdditionalFileIEnumerableResponse> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormAdminGetComplianceFormAdditionalFilesComplianceFormIdGet(complianceFormId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Compliance Form Files
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormAdminGetComplianceFormFilesComplianceFormIdGet(complianceFormId: number, options?: any): AxiosPromise<ComplianceFormFileResponse> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormAdminGetComplianceFormFilesComplianceFormIdGet(complianceFormId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Compliance Forms
         * @param {AdminComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormAdminGetComplianceFormsPost(body?: AdminComplianceFormRequest, options?: any): AxiosPromise<ComplianceFormTipIEnumerableResponse> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormAdminGetComplianceFormsPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns boolean if Generate Trust Compliance Form is enabled
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormAdminIsGenerateTrustComplianceFormEnablePracticeIdGet(practiceId: number, options?: any): AxiosPromise<GenerateNextYearTrustComplianceFormResponse> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormAdminIsGenerateTrustComplianceFormEnablePracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All  | Update Compliance Form Absolution
         * @param {ComplianceFormAbsolutionRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormAdminUpdateComplianceFormAbsolutionPost(body?: ComplianceFormAbsolutionRequest, options?: any): AxiosPromise<BooleanResponse> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormAdminUpdateComplianceFormAbsolutionPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / Trust Coordinator / Trust Contact / ExternalExaminer | Returns Compliance Forms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormGetComplianceFormsGet(options?: any): AxiosPromise<ComplianceFormIEnumerableResponse> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormGetComplianceFormsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / TrustCoordinator / TrustContact / ExternalExaminer | Returns Compliance Years
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormGetComplianceYearsGet(options?: any): AxiosPromise<ComplianceYearIEnumerableResponse> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormGetComplianceYearsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Principal / TrustCoordinator / TrustContact / ExternalExaminer | Returns Progresses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormGetProgressesGet(options?: any): AxiosPromise<ProgressIEnumerableResponse> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormGetProgressesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Trust Investigator only | Returns ComplianceForm AdditionalFiles
         * @param {number} complianceFormId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormTrustInvestigatorGetComplianceFormAdditionalFilesComplianceFormIdGet(complianceFormId: number, options?: any): AxiosPromise<Array<AdditionalFile>> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormTrustInvestigatorGetComplianceFormAdditionalFilesComplianceFormIdGet(complianceFormId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Trust Investigator only | Returns Compliance Forms
         * @param {AdminComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormTrustInvestigatorGetComplianceFormsPost(body?: AdminComplianceFormRequest, options?: any): AxiosPromise<Array<ComplianceFormTrustInvestigator>> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormTrustInvestigatorGetComplianceFormsPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Trust Investigator only | Returns Compliance Forms
         * @param {AdminComplianceFormRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ComplianceFormTrustInvestigatorGetComplianceFormsTipPost(body?: AdminComplianceFormRequest, options?: any): AxiosPromise<Array<ComplianceFormTip>> {
            return ComplianceFormApiFp(configuration).apiV2ComplianceFormTrustInvestigatorGetComplianceFormsTipPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComplianceFormApi - object-oriented interface
 * @export
 * @class ComplianceFormApi
 * @extends {BaseAPI}
 */
export class ComplianceFormApi extends BaseAPI {
    /**
     * 
     * @summary TaAll | Dashboard Number Of Compliant Forms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormAdminDashboardGetNumberOfCompliantFormsGet(options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormAdminDashboardGetNumberOfCompliantFormsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Generate Next Year Trust ComplianceForm
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormAdminGenerateNextYearTrustComplianceFormPracticeIdGet(practiceId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormAdminGenerateNextYearTrustComplianceFormPracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Compliance Form Absolution
     * @param {number} complianceFormId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormAdminGetComplianceFormAbsolutionComplianceFormIdGet(complianceFormId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormAdminGetComplianceFormAbsolutionComplianceFormIdGet(complianceFormId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns ComplianceForm AdditionalFiles
     * @param {number} complianceFormId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormAdminGetComplianceFormAdditionalFilesComplianceFormIdGet(complianceFormId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormAdminGetComplianceFormAdditionalFilesComplianceFormIdGet(complianceFormId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Compliance Form Files
     * @param {number} complianceFormId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormAdminGetComplianceFormFilesComplianceFormIdGet(complianceFormId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormAdminGetComplianceFormFilesComplianceFormIdGet(complianceFormId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Compliance Forms
     * @param {AdminComplianceFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormAdminGetComplianceFormsPost(body?: AdminComplianceFormRequest, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormAdminGetComplianceFormsPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns boolean if Generate Trust Compliance Form is enabled
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormAdminIsGenerateTrustComplianceFormEnablePracticeIdGet(practiceId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormAdminIsGenerateTrustComplianceFormEnablePracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All  | Update Compliance Form Absolution
     * @param {ComplianceFormAbsolutionRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormAdminUpdateComplianceFormAbsolutionPost(body?: ComplianceFormAbsolutionRequest, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormAdminUpdateComplianceFormAbsolutionPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / Trust Coordinator / Trust Contact / ExternalExaminer | Returns Compliance Forms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormGetComplianceFormsGet(options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormGetComplianceFormsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / TrustCoordinator / TrustContact / ExternalExaminer | Returns Compliance Years
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormGetComplianceYearsGet(options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormGetComplianceYearsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Principal / TrustCoordinator / TrustContact / ExternalExaminer | Returns Progresses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormGetProgressesGet(options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormGetProgressesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Trust Investigator only | Returns ComplianceForm AdditionalFiles
     * @param {number} complianceFormId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormTrustInvestigatorGetComplianceFormAdditionalFilesComplianceFormIdGet(complianceFormId: number, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormTrustInvestigatorGetComplianceFormAdditionalFilesComplianceFormIdGet(complianceFormId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Trust Investigator only | Returns Compliance Forms
     * @param {AdminComplianceFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormTrustInvestigatorGetComplianceFormsPost(body?: AdminComplianceFormRequest, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormTrustInvestigatorGetComplianceFormsPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Trust Investigator only | Returns Compliance Forms
     * @param {AdminComplianceFormRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceFormApi
     */
    public apiV2ComplianceFormTrustInvestigatorGetComplianceFormsTipPost(body?: AdminComplianceFormRequest, options?: any) {
        return ComplianceFormApiFp(this.configuration).apiV2ComplianceFormTrustInvestigatorGetComplianceFormsTipPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
